<template>
  <div style="background: #2A2A2A;">    
        <div align="center"
          justify="center">
          <v-dialog v-model="dialog" width="80%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text class="mt-3" v-bind="attrs" v-on="on"> <span class="ml-1 mr-1  white--text">이용약관</span></v-btn>
            </template>            
            <iframe src="http://www.karmalab.me/terms.html" name="test" height="600" frameborder="0" scrolling="yes" align="left">이 브라우저는 iframe을 지원하지 않습니다</iframe>            
          </v-dialog>
        


        <v-dialog v-model="dialog2" width="80%">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="mt-3" v-bind="attrs" v-on="on"> <span class="ml-1 mr-1 white--text">개인정보처리 방침</span></v-btn>
          </template>
          <iframe src="http://www.karmalab.me/privacy.html" name="test" height="600" frameborder="0" scrolling="yes" align="left">이 브라우저는 iframe을 지원하지 않습니다</iframe>            
        </v-dialog>
        
        </div>
        <div align="center" class="pb-4">
          <p class="grey--text font-weight-light">©{{ new Date().getFullYear() }} Karmalab Inc. All right reserved.</p>          
        </div>      
  </div>
</template>

<script>
  export default {
    data: () => ({    
      dialog : false,      
      dialog2 : false,
    }),
  }
</script>


<style>

.header_margin {    
  width:100%;
  height:50px;  
}
/* .header_text {    
  background: #000000;   
} */
.content_get {    
  width:100%;
 
  background: #FFFFFF;   
}
.content_why {    
  width:100%;  
  background: #2A2A2A;   
}


#line-height {
  line-height:200%;
}

#item-box {
  width:300px;
  line-height:200%;
}

#item-box2 {
  width:200px;
  line-height:200%;
}
#item-box3 {
  width:400px;
  line-height:200%;
}

 
</style>